import {call,query} from "./calls";
const QUERY_LIMIT = 100;
export const PackagedAppArtifacts = {
  add:(payload) => call(`/PackagedAppArtifacts/${payload.artifactId}`,"PUT",{"_command":{"command":"add","payload": payload}}),
  remove:(appId,artifactId) => call(`/PackagedAppArtifacts/${artifactId}`,"PUT",{"_command":{"command":"delete","payload":{appId,artifactId}}}),
  getArtifacts:(artifactType,name) => query(`select id as artifactId,name as artifactName from ${artifactType} where name like '${name}' limit ${QUERY_LIMIT}`),
  getByAppId:(appId) => query(`Select artifacts from PackagedAppArtifacts where appId = ${appId}`)
}
